module.exports = __webpack_public_path__ + "static/media/Back.7173fe1b.jpg";